<ng-container *ngIf="mediaFeatures && !mediaFeatures.onPrem && !mediaFeatures.webcastSources.webrtcSinglePresenterDisabled">
	<div class="dropdown" dropdown vbDropdown #goLiveFormDropdown="bs-dropdown" (onHidden)="resetForm()" [insideClick]="true" *vbAuthorizationKey="'events.add'">
		<button dropdownToggle class="dropdown-toggle flex-center-align go-live btn main-nav-btn" type="button" [attr.aria-label]="('Event_GoLive' | translate) + ' - ' + ('UI_Menu' | translate)" [ngClass]="{
				'open': goLiveFormDropdown.isOpen,
				'bg-none': bgNone,
				'btn': headerType !== 'Classic'
			}">
			<span [ngClass]="[
					!goLiveFormDropdown.isOpen || !showRemove ? 'vb-icon vb-icon-center vb-icon-go-live' : '',
					goLiveFormDropdown.isOpen && showRemove ? 'glyphicons remove_2 rotate-360-once': '',
					iconCssClass
				]">
			</span>
		</button>
		<div *dropdownMenu #formDropDown role="dialog" class="dropdown-menu go-live-menu dropdown-menu-right keep-border-radius" [ngClass]="styles.goLiveMenu">
			<go-live-form [mediaFeatures]="mediaFeatures" (close)="goLiveFormDropdown.hide()" [ngClass]="styles.goLive"></go-live-form>
		</div>
	</div>
</ng-container>
